import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
import Alert from "react-s-alert";
import {Label} from "reactstrap";
import './MemberTransferList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";

class MemberAccept extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading:false,
            authRoles: [],
            cities:[],
            fieldsDisabled: false,
            mode:this.props.mode,
            hasTransfer:false,
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: "",
                kimlikTipi:"",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: "",
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                mezuniyetTarihi: "",
                diplomaNo: "",
                ruhsatTarihi: "",
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile:"",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: false,
                uyelikAktif: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                transferTo:"",
                city: {
                    id: null,
                    plakaKod : null,
                    ad : null,
                    oda : {
                        id : null,
                        ad: null,
                        adres : null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                }
            },
        };
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeSelect=this.onChangeSelect.bind(this);
        this.handleAcceptTransfer=this.handleAcceptTransfer.bind(this);
        this.handleLogout=this.handleLogout.bind(this);

    }

    async  componentDidMount() {

        console.log("this.props.selectedMember this.props.cities", this.props.selectedMember, this.props.cities)
        if (this.props.selectedMember) {
            let selectedMember = deepCopyObject(this.props.selectedMember);
            this.setState({memberInfo: selectedMember});
        }

        if(this.props.selectedMember.transferTo!==null) {
            this.setState({hasTransfer: true});
        }
    }

    onChangeSelect(name,value){
        let memberInfo=this.state.memberInfo;
        if(value===null) {
            memberInfo[name]=null}
        else {
            memberInfo[name]=value.value;
        }
        this.setState({memberInfo });
    }


    handleAcceptTransfer() {
        let self = this;
        let message = 'Üye Odaya Başarıyla Kabul Edildi.'
        let params = {
            url: API_BASE_URL + "/uye/accept-transfer/"+this.state.memberInfo.id,
            method: 'get'
        };
        self.setState({isLoading:true});
        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
            self.setState({isLoading:false});
            self.cancelProcess();
            self.props.handleSearch();
        }).catch(function (error) {
            self.setState({isLoading:false});
            showAxiosError(error);
        });
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        return (
            <div>
                {
                    (this.state.isLoading)&&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">Üyenin Mevcut Bilgileri</h4>
                </div>
                <div className="memberTransferForm-container">
                    <div className="card-body mt-1">
                        <div className="FormRenk col-sm-12">
                            <div className="row">
                                <Label className="col-sm-2">Sicil No:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.odaSicilNo}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Ad:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Soyad:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.soyad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">TC Kimlik No:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.tcKimlikNo}</Label>
                            </div>

                            <div className="row">
                                <Label className="col-sm-2">İl:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.city.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Oda:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.city.oda.ad}</Label>
                            </div>
                        </div>
                    </div>
                    <div className='card-header'>
                        <h4 className="card-title">Üyenin Transfer Edileceği İl/Oda Bilgileri</h4>
                    </div>
                    <div className="memberTransferForm-container">
                        <div className="card-body mt-1">
                            <div className="FormRenk col-sm-12">

                                <div className="row">
                                    <Label className="col-sm-2">İl:</Label>
                                    <Label className="col-sm-10">{this.state.memberInfo.transferTo&&this.props.cities&&this.props.cities[this.state.memberInfo.transferTo-1].ad}</Label>
                                </div>
                                <div className="row">
                                    <Label className="col-sm-2">Oda:</Label>
                                    <Label className="col-sm-10">{this.state.memberInfo.transferTo&&this.props.cities&&this.props.cities[this.state.memberInfo.transferTo-1].oda.ad}</Label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="new-button-holder">
                            <button type="button"
                                    onClick={() => this.handleAcceptTransfer()}
                                    disabled={this.state.isLoading}
                                    data-toggle="tooltip" data-placement="bottom" title="Onayla"
                                    rel="tooltip" className="save">Üyeyi Odaya Kabul Et</button>
                    </div>
                </div>
            </div>
        )
    }
}
export default MemberAccept;


// WEBPACK FOOTER //
// ./src/page/memberTransferList/MemberAccept.js